import React from 'react'

import { FormWrapper, InputWrapper, InputLabel, Input, TextArea, Submit } from './styles.js'

class Form extends React.Component {

    render() {
        return (
            <FormWrapper name='contact' method='post' action='/success' data-netlify='true' data-netlify-honeypot='bot-field'>
                
                <input type='hidden' name='bot-field' />
                <input type='hidden' name='form-name' value='contact' />

                <InputWrapper>
                    <InputLabel htmlFor='name'>Your Name*</InputLabel>
                    <Input type='text' name='name' id='name' required />
                </InputWrapper>
                <InputWrapper>
                    <InputLabel htmlFor='email'>Your Email*</InputLabel>
                    <Input type='email' name='email' id='email' required />
                </InputWrapper>
                <InputWrapper>
                    <InputLabel htmlFor='question'>Your Question*</InputLabel>
                    <TextArea name='question' id='question' rows='4' required />
                </InputWrapper>
                <InputWrapper>
                    <Submit type='submit' value='Send Now' />
                </InputWrapper>
                
            </FormWrapper>
        )
    }

}

export default Form